"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _ActiveCurrencyCode = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/ActiveCurrencyCode"));

var _ActiveHub = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/ActiveHub"));

var _Auth = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/Auth"));

var _Config = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/Config"));

var _Country = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/Country"));

var _CustomerCurrencyCode = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/CustomerCurrencyCode"));

var _NumContactsInCrm = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/NumContactsInCrm"));

var _Parcels = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/Parcels"));

var _Merchandise = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/Merchandise"));

var _PurchaseMotionsByLocation = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/PurchaseMotionsByLocation"));

var _RequiredOnboarding = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/RequiredOnboarding"));

var _Settings = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/Settings"));

var _UsersInPortal = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/UsersInPortal"));

var _Promotions = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/Promotions"));

var _PhoneNumbers = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/PhoneNumbers"));

var _ExperimentTreatments = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/ExperimentTreatments"));

var _PurchaseMotionRequestStatus = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/PurchaseMotionRequestStatus"));

var _SubscriptionTerms = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/SubscriptionTerms"));

var _MerchandiseIdsTreatedAsOwned = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/MerchandiseIdsTreatedAsOwned"));

var _PublicFeatureFlags = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/PublicFeatureFlags"));

var _CovidSuitePromoCheckoutEligibility = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/CovidSuitePromoCheckoutEligibility"));

var _ActiveTerm = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/ActiveTerm"));

var _MarketingContacts = _interopRequireDefault(require("pricing-pages-unified-ui/reducers/MarketingContacts"));

var _default = (0, _redux.combineReducers)({
  activeCurrencyCode: _ActiveCurrencyCode.default,
  activeHub: _ActiveHub.default,
  activeTerm: _ActiveTerm.default,
  auth: _Auth.default,
  config: _Config.default,
  country: _Country.default,
  customerCurrencyCode: _CustomerCurrencyCode.default,
  subscriptionTerms: _SubscriptionTerms.default,
  merchandise: _Merchandise.default,
  parcels: _Parcels.default,
  settings: _Settings.default,
  numContactsInCrm: _NumContactsInCrm.default,
  purchaseMotionsByLocation: _PurchaseMotionsByLocation.default,
  requiredOnboarding: _RequiredOnboarding.default,
  usersInPortal: _UsersInPortal.default,
  promotions: _Promotions.default,
  phoneNumbers: _PhoneNumbers.default,
  experimentTreatments: _ExperimentTreatments.default,
  purchaseMotionRequestStatus: _PurchaseMotionRequestStatus.default,
  merchandiseIdsTreatedAsOwned: _MerchandiseIdsTreatedAsOwned.default,
  publicFeatureFlags: _PublicFeatureFlags.default,
  covidSuitePromoCheckoutEligibility: _CovidSuitePromoCheckoutEligibility.default,
  marketingContacts: _MarketingContacts.default
});

exports.default = _default;
module.exports = exports.default;